import { useContext, useState } from "react";

import { TransitionGroup } from "react-transition-group";

import { css } from "@emotion/react";
import CircularProgress from "@mui/material/CircularProgress";

import { useMediaQueries } from "../../../../../shared";
import NotificationsContext from "../../../notificationsContext";
import NoNotifications from "./NoNotifications";
import ShowAllButton from "./ShowAllButton";
import SingleNotification from "./SingleNotification";
import { NotificationListProps } from "./types";

const NotificationList = ({ isLoading }: NotificationListProps) => {
    const { notifications } = useContext(NotificationsContext);

    const { fromMd } = useMediaQueries();

    const [isShowingAll, setIsShowingAll] = useState(false);

    const renderContent = () => {
        if (isLoading) {
            return (
                <div
                    css={css({
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        minHeight: "104px"
                    })}
                >
                    <CircularProgress />
                </div>
            );
        }

        const hasNotifications = notifications.length > 0;
        const hasShowAllBtn = notifications.length > 10 && !isShowingAll;

        return hasNotifications ? (
            <ul
                css={css({
                    overflowY: "auto",
                    overflowX: "hidden",
                    maxHeight: fromMd ? "536px" : "unset",

                    ".slide-exit-active": {
                        filter: "blur(2px)",
                        transform: "translateX(100%)",
                        transition: "all 300ms cubic-bezier(0, 0, 0.2, 1)"
                    }
                })}
            >
                <TransitionGroup component={null}>
                    {notifications.map((notification, i) => {
                        const shouldShow =
                            notification && (isShowingAll || i < 10);

                        return (
                            shouldShow && (
                                <SingleNotification
                                    key={notification.id}
                                    data={notification}
                                />
                            )
                        );
                    })}
                </TransitionGroup>

                {hasShowAllBtn && <ShowAllButton showAll={setIsShowingAll} />}
            </ul>
        ) : (
            <NoNotifications />
        );
    };

    return renderContent();
};

export default NotificationList;
